import React from 'react'
import { Label } from 'reactstrap'
import PropTypes from 'prop-types'

const FieldLabel = ({
  name, title, required,
}) => (
  <Label for={name}>
    {title}
    {required && (
      <span className="text-danger">
        *
      </span>
    )}
  </Label>
)

FieldLabel.defaultProps = {
  required: false,
}

FieldLabel.propTypes = {
  name    : PropTypes.string.isRequired,
  title   : PropTypes.string.isRequired,
  required: PropTypes.bool,
}

export default FieldLabel
